<template>
  <Picker
    color="#0085FF"
    :data="emojiIndex"
    :show-search="false"
    :native="true"
    :show-preview="false"
    @select="onSelect"
  />
</template>

<script>
import data from 'emoji-mart-vue-fast/data/all.json'
import { Picker, EmojiIndex } from 'emoji-mart-vue-fast/src'
import 'emoji-mart-vue-fast/css/emoji-mart.css'

const emojiIndex = new EmojiIndex(data)

export default {
  name: 'EmojiMart',
  components: {
    Picker
  },
  emits: ['select'],
  setup (props, { emit }) {
    function onSelect (emoji) {
      emit('select', emoji.native)
    }

    return {
      emojiIndex,
      onSelect
    }
  }
}
</script>
